import React, {useState} from 'react';

import {UncontrolledTooltip} from 'reactstrap';

import {ContentEditable} from 'app/components/general/Mentionable';
import StateButton from 'app/general/widgets/StateButton';
import {gt} from 'app/utils/i18n';

interface Props {
  MentionableField: typeof ContentEditable;
  mentionableFieldProps: {
    ref: {
      current: HTMLElement | null;
    };
    value: string;
    onChange: (content: string) => void;
    onSubmit: (
      event: React.KeyboardEvent<HTMLDivElement>,
      currentComment?: string
    ) => void;
  };
  className: string;
  buttonClass: string;
  inputClass: string;
  submitButtonDisabled: boolean;
  isIdle: boolean;
  hideTooltip: boolean;
}

export function CommentTextForm({
  className,
  inputClass,
  buttonClass,
  MentionableField,
  mentionableFieldProps,
  submitButtonDisabled,
  isIdle,
  hideTooltip,
}: Props) {
  const [fieldRef, setFieldRef] = useState<null | HTMLElement>(null);

  function interceptRef(ref: {current: null | HTMLElement}) {
    const originalRef = ref;

    return (newFieldRef: null | HTMLElement) => {
      setFieldRef(newFieldRef);

      if (originalRef != null) {
        originalRef.current = newFieldRef;
      }
    };
  }

  return (
    <>
      <div className={className}>
        <div className="input-group">
          <MentionableField
            className={`form-control rounded-0 border-left-0 ${inputClass}`}
            autoFocus={true}
            style={{
              height: 'auto',
              maxHeight: '8em',
              overflow: 'auto',
            }}
            placeholder={gt('Leave a comment')}
            {...mentionableFieldProps}
            ref={interceptRef(mentionableFieldProps.ref)}
          />
          <div className="input-group-append">
            <StateButton
              style={{
                boxShadow: 'none',
              }}
              className={`btn rounded-0 ${buttonClass}`}
              busyContent={<i className="fa fa-circle-notch fa-spin" />}
              disabled={submitButtonDisabled}
              isIdle={isIdle}
              onClick={() => undefined}
              type="submit"
            >
              <i className="fa fa-paper-plane" />
            </StateButton>
          </div>
        </div>
      </div>
      {fieldRef != null && submitButtonDisabled && hideTooltip !== true ? (
        <UncontrolledTooltip delay={250} target={fieldRef}>
          {gt('Use the @ symbol to mention a teammate')}
        </UncontrolledTooltip>
      ) : null}
    </>
  );
}
